import type { RecommendationRenameProps } from "./recommendation-rename.type";

import { Typography, Skeleton } from "antd";

import { useRecommendationUpdate } from "@/entities/recommendation";

import "./recommendation-rename.style.less";

const { Text } = Typography;

const RecommendationRename = ({
  recommendation,
  interventionId,
  isEditable,
  isLoading,
}: RecommendationRenameProps) => {
  const { updateRecommendation, isPending } = useRecommendationUpdate({
    recommendationId: recommendation.id,
    interventionId,
  });

  const loading = isLoading || isPending;
  const onChange = (newTitle: string) => {
    updateRecommendation({ name: newTitle });
  };

  return (
    <div className="recommendation-rename">
      {loading ? (
        <Skeleton.Input size="small" active className="full-width-skeleton" />
      ) : (
        <Text
          ellipsis
          editable={isEditable ? { onChange } : undefined}
          className="recommendation-rename"
        >
          {recommendation.name}
        </Text>
      )}
    </div>
  );
};

export default RecommendationRename;
